export const generateDirectusSrcSet = (id?: string | null) => {
  if (!id) return undefined;
  const baseUrl = (process.env.NEXT_PUBLIC_BASE_URL || '').replace(/\/$/, '');
  const cleanId = String(id)
    .replace(/^\/assets\//, '')
    .replace(/^\//, '');
  return `${baseUrl}/assets/${cleanId}?width=150&quality=80&format=webp 150w, ${baseUrl}/assets/${cleanId}?width=300&quality=80&format=webp 300w, ${baseUrl}/assets/${cleanId}?width=600&quality=80&format=webp 600w, ${baseUrl}/assets/${cleanId}?width=900&quality=80&format=webp 900w, ${baseUrl}/assets/${cleanId}?width=1200&quality=80&format=webp 1200w`;
};

export const generateDirectusSrc = (
  id?: string | null,
  _defaultWidth?: number,
  _quality?: number,
  _format?: string
) => {
  if (!id) return '';
  const baseUrl = (process.env.NEXT_PUBLIC_BASE_URL || '').replace(/\/$/, '');
  const strId = String(id);
  if (strId.startsWith('http://') || strId.startsWith('https://')) {
    return strId;
  }
  const cleanId = strId.replace(/^\/assets\//, '').replace(/^\//, '');
  return `${baseUrl}/assets/${cleanId}`;
};
